import { LOADING, SET_MESSAGE } from "../../Actions/Types";
import { AddBillingAddressApi, deleteBillingAddressApi, getBillingAddressApi, getCountryListApi, makeDefaultBillingAddressApi, UpdateBillingAddressApi } from "../../Api/BillingAddressApi";
import { AddVoiceCommandApi, deleteVoiceCommandApi, getVoiceCommandApi, UpdateVoiceCommandApi } from "../../Api/VoiceCommandApi";
import { BillingAddressPropTypes } from "../../PropTypes/BillingAddressPropTypes";
import { getUserDetailsService } from "../../Services/UserAction/LoginActionService";

const AddVoiceCommandService = (
  website_id: string,
  command_title: string, // Command title
  description: string, // Command description
  command_value: string, // Command URL
  accessToken:string,
  setVoiceCommandListData: Function, // dispatch function to store redux data
  setShowVoiceCommandPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  AddVoiceCommandApi(website_id, command_title,description, command_value, accessToken).then((response) => {
      // remove Loading
       if (response.data) {
            // service to get card list
            getVoiceCommandService(accessToken, website_id, setVoiceCommandListData, dispatch, t);

        }
      dispatch({
        type: LOADING,
        payload: false,
      });

      setShowVoiceCommandPopup(false)
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.message),
          toast_type: "success",
        },
      });

      resetForm()
  });
};

const UpdateVoiceCommandService = (
  id:number,
  website_id: string,
  command_title: string, // Command title
  description: string, // Command description
  command_value: string, // Command URL
  accessToken:string,
  setVoiceCommandListData: Function, // dispatch function to store redux data
  setShowVoiceCommandPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function,
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  UpdateVoiceCommandApi(id,website_id, command_title, description, command_value, accessToken).then((response) => {
    // remove Loading
    if (response.data) {
        
        // service to get card list
        getVoiceCommandService(accessToken, website_id, setVoiceCommandListData, dispatch, t);

    }
    dispatch({
    type: LOADING,
    payload: false,
    });

    setShowVoiceCommandPopup(false)
    dispatch({
    type: SET_MESSAGE,
    payload: {
        toast_message: t(response.message),
        toast_type: "success",
    },
    });

    resetForm()
  });
};


// service to get card list
const getVoiceCommandService = (
    accessToken: string, // access token
    website_id: string, // domain id
    setVoiceCommandListData: Function, // function to set Voice Command list
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // API to get card list
    getVoiceCommandApi(accessToken, website_id).then(response => {
        // check response data is available
        if (response.data) {
            setVoiceCommandListData(response.data);
        }
    })
}

// service to delete card
const deleteVoiceCommandService = (
    accessToken: string, // access token
    website_id: string, // domain
    defaultVoiceCommandID: number, // voice command Id
    setVoiceCommandListData: Function, // function to voice command list
    setDeleteVoiceCommandPopup: Function, // function to close voice command popup
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // API to delete card
    deleteVoiceCommandApi(accessToken, defaultVoiceCommandID).then(response => {
        // check if response data is available
        if (response) {
            //setCardListData(response.Data);

            // service to get card list
            getVoiceCommandService(accessToken, website_id, setVoiceCommandListData, dispatch, t);

            // hide delete card popup
            setDeleteVoiceCommandPopup(false)

            // dispatch card delete success message
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Voice Command Deleted Successfully!'),
                    "toast_type": "success"
                }
            })
        }
    })
}


export {
  AddVoiceCommandService,
  getVoiceCommandService,
  deleteVoiceCommandService,
  UpdateVoiceCommandService
};
